export default __webpack_public_path__ + "static/media/img-0165-italy-half-face.0a77feab.png";